<template>
    <b-overlay :show="showOverlay" rounded="sm">
        <Bar
            v-if="chartLoaded"
            id="chart"
            :options="chartOptions"
            :data="chartData"
            :style="styles" />
    </b-overlay>
</template>

<script>
import { Bar } from "vue-chartjs";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
import API_ROUTES from '@/api/routes';
import fixedTermRatesMock from "@/assets/mocks/fixedTermRatesMock.json";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
);

export default {
    name: "BarChart",
    components: { Bar },
    computed: {
        styles() {
            return {
                color: "#8C08B9",
                position: "relative",
            };
        },
    },
    data() {
        return {
            showOverlay: false,
            chartLoaded: false,
            fixedTermRates: [],
            chartData: {
                labels: ["January", "February", "March"],
                datasets: [
                    {
                        label: "TNA p/ Clientes",
                        data: [],
                        backgroundColor: ["#8C08B9"],
                    },
                ],
            },
            chartOptions: {
                responsive: true,
                scales: {
                    x: {
                        ticks: {
                            color: "black",
                            font: {
                                weight: "bold",
                                size: "14",
                            },
                        },
                    },
                    y: {
                        ticks: {
                            color: "#8C08B9",
                            font: {
                                weight: "bold",
                                size: "14",
                            },
                            callback: function (value) {
                                return value + "%";
                            },
                        },
                        beginAtZero: true,
                    },
                },
                plugins: {
                    legend: {
                        labels: {
                            color: "black",
                            font: {
                                weight: "bold",
                                size: "14",
                            }
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return tooltipItem.raw + "%";
                            },
                        },
                    },
                },
            },
        };
    },
    async mounted() {

    },

    async created() {
        await this.getFixedTermRates();

        // Mock
        // this.chartData.labels = fixedTermRatesMock.data.map(
        //     (item) => item.entity
        // );

        // this.chartData.datasets[0].data = fixedTermRatesMock.data.map(
        //     (item) => item.noClientsTna
        // );
    },

    methods: {
        async getFixedTermRates() {
            this.showOverlay = true;
            this.chartLoaded = false;

            this.$axios.get(API_ROUTES.GET_FIXED_TERM_RATES)
            .then(res => {
                //console.log(res.data);
                
                if (res.data?.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                } else {
                    this.fixedTermRates = res.data.data;
                    
                    this.chartData.labels = this.fixedTermRates.map(
                        (item) => item.entity
                    );

                    this.chartData.datasets[0].data = this.fixedTermRates.map(
                        (item) => item.noClientsTna
                    );

                    this.chartLoaded = true;
                }
            })
            .catch(e => {
                //console.log(e);
                this.showNotification("error", "No fue posible cargar los datos. Error: " + e);
            })
            .finally(e => {
                this.showOverlay = false;
            })

        },
    }
};
</script>